import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ServiceApi } from '../genericApi/service-api';
import { ConfigService } from '../../Core/Config/services/config.service';
import { ConfigModel } from '../../Core/Config/models/config.model';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { TargetingQuotaApiModel } from './model/targeting-quota-api.model';

@Injectable()
export class TargetingQuotaApi {
    private apiUrl: string;

    constructor(
        private serviceApi: ServiceApi,
        private configurationService: ConfigService
    ) {
        const config: ConfigModel = this.configurationService.getConfig();
        this.apiUrl = config.apiUrl;
    }

    getCurrentAccountTargetingQuota(): Observable<TargetingQuotaApiModel> {
        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<TargetingQuotaApiModel>(
            '/targetingquota/accounts/mine',
            null,
            HttpVerbsEnum.GET,
        );
    }

    getAccountTargetingQuota(accountId: number): Observable<TargetingQuotaApiModel> {
        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<TargetingQuotaApiModel>(
            `/targetingquota/accounts/${accountId}`,
            null,
            HttpVerbsEnum.GET,
        );
    }

    /**
     * Sets the reset date for the given account id. If date is null, it is equivalent to
     * removing the custom reset date in favour of the system reset date.
     */
    setAccountQuotaResetDate(accountId: number, date: Date): Observable<void> {
        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<void>(
            `/targetingquota/accounts/${accountId}`,
            {
                customResetDate: date
            },
            HttpVerbsEnum.PATCH,
        );
    }
}
